import React from 'react'
import ReactModal from 'react-modal'

import CrossIcon from '../../../assets/icons/cross.svg'
import { Message } from '../../utilites'

const AlertModal = ({ isOpen, handleClose, header, text }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel='Modal'
      className='modal-container'
      overlayClassName='modal-overlay'
    >
      <div className='modal-header'>
        <h2>{header}</h2>
        <button className='button-icontrigger modal-closetrigger' onClick={handleClose}>
          <span className='icon'><CrossIcon /></span>
        </button>
      </div>
      <div className='modal-body'>
        <Message type='error' text={text} />
      </div>
      <div className='modal-footer contractAdd-modal-footer'>
        <button type='button' className='button' onClick={handleClose}>
          Закрыть
        </button>
      </div>
    </ReactModal>
  )
}

export default AlertModal
